export default __webpack_public_path__ + "static/img_spindlebooks_ipad@2x-01d3cab9699a8e06cc306239ef8fd25e.png";